import { IInfrastructureType } from '../../../common/types/infrastructure';
import { IMapState } from '../../types';

// мемоизация по ссылке на types: Object.values создавал новый массив на каждый
// вызов и заставлял подписчиков ре-рендериться на каждый диспатч
let lastTypes: IMapState['map']['infrastructure']['types'] | null = null;
let lastResult: IInfrastructureType[] = [];

export function selectTypes(state: IMapState): IInfrastructureType[] {
  const { types } = state.map.infrastructure;

  if (types !== lastTypes) {
    lastTypes = types;
    lastResult = Object.values(types);
  }

  return lastResult;
}
